import React from 'react'
import PropTypes from 'prop-types'

import DatePicker from 'react-datepicker'
import moment from 'moment'
import { Button, Form, Message, Modal } from 'semantic-ui-react'
import { compose } from 'recompose'

import Container from './EditReservationModalContainer'
import Enhancer from './EditReservationModalEnhancer'

import FormInputDropdownAddition from 'Components/FormInputDropdownAddition'

import * as styles from './styles'
import { getReservedDates, getLastAllowedReserveDate, getFirstAllowedDate } from 'Global/Helpers/reservationHelpers'

import 'react-datepicker/dist/react-datepicker.css'

const EditReservationModal = props => {
  const {
    close,
    dateFrom,
    dateTo,
    errors,
    event,
    eventOptions,
    handleDelete,
    handleEventChanged,
    handleEventItemAdded,
    handleEventReset,
    handleFromPicked,
    handleReasonChanged,
    handleSubmit,
    handleToPicked,
    hasError,
    isPending,
    reason,
    reservation,
    reservations,
  } = props

  const reservedDates = getReservedDates(reservations, reservation.id)

  return (
    <Modal onClose={close} open={true}>
      <Modal.Header>Edit Reservation</Modal.Header>
      <Modal.Content>
        {hasError && <Message content="This wasn&#39;t supposed to happen. Please try again." header="An Error Occured." error />}

        <Form onSubmit={handleSubmit} size="tiny">
          <Form.Group style={styles.outerFormGroup}>
            <Form.Group style={styles.innerFormGroup} widths="equal">
              <Form.Field error={errors.dates}>
                <label>From</label>
                <DatePicker
                  dateFormat="DD.MM.YYYY"
                  excludeDates={reservedDates}
                  minDate={moment(getFirstAllowedDate(reservations, reservation.id))}
                  name="dateFrom"
                  onChange={handleFromPicked}
                  placeholderText="From"
                  selected={dateFrom}
                />
              </Form.Field>

              <Form.Field error={errors.dates}>
                <label>To</label>
                <DatePicker
                  dateFormat="DD.MM.YYYY"
                  excludeDates={reservedDates}
                  maxDate={moment(getLastAllowedReserveDate(dateFrom, reservations, reservation.id))}
                  minDate={moment(dateFrom)}
                  name="dateTo"
                  onChange={handleToPicked}
                  placeholderText="To"
                  selected={dateTo}
                />
              </Form.Field>

              <FormInputDropdownAddition
                error={errors.event}
                name="event"
                onAddItem={handleEventItemAdded}
                onChange={handleEventChanged}
                options={eventOptions}
                pending={isPending}
                reset={handleEventReset}
                resetVisible={!!event}
                text={'Event'}
                value={event}
              />
            </Form.Group>
          </Form.Group>
          <Form.Field>
            <Form.TextArea
              error={errors.reason}
              label="Reason"
              name="reason"
              onChange={handleReasonChanged}
              placeholder="Reason"
              rows={2}
              style={styles.inputReason}
              type="text"
              value={reason}
            />
          </Form.Field>

          <span>Specify at least an event or a reason. You can add events that don't exist yet.</span>

          <div style={{ textAlign: 'right' }}>
            <Button color="red" content="Delete" icon={hasError ? 'warning sign' : 'trash'} loading={isPending} onClick={handleDelete} />
            <Button color="black" content="Edit Reservation" icon={hasError ? 'warning sign' : 'bookmark'} loading={isPending} />
          </div>
        </Form>
      </Modal.Content>

      <Modal.Actions>
        <Button color="black" content="Close" onClick={close} />
      </Modal.Actions>
    </Modal>
  )
}

EditReservationModal.propTypes = {
  close: PropTypes.func.isRequired,
  dateFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  dateTo: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  errors: PropTypes.object.isRequired,
  event: PropTypes.string.isRequired,
  eventOptions: PropTypes.array.isRequired,
  handleDelete: PropTypes.func.isRequired,
  handleEventChanged: PropTypes.func.isRequired,
  handleEventItemAdded: PropTypes.func.isRequired,
  handleEventReset: PropTypes.func.isRequired,
  handleFromPicked: PropTypes.func.isRequired,
  handleReasonChanged: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  handleToPicked: PropTypes.func.isRequired,
  hasError: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  reason: PropTypes.string.isRequired,
  reservation: PropTypes.object.isRequired,
  reservations: PropTypes.array.isRequired,
}

const composed = compose(
  Enhancer,
  Container,
)

export default composed(EditReservationModal)
